import classNames from 'classnames';

import { Button, Flex, Text } from '@mantine/core';

import IconChevronRight from '@/shared/uikit/assets/icons/IconChevronRight.svg?react';

import classes from './IconicRow.module.css';

type IconicRowProps = {
	mainText: string;
	dimmedText?: React.ReactNode;
	badge?: string;
	rightContentSlot?: React.ReactNode;
	disabled?: boolean;
	clickable?: boolean;
	onClick?(event: React.MouseEvent<HTMLDivElement>): void;
};

export const IconicRow = ({
	mainText,
	dimmedText,
	badge,
	rightContentSlot,
	disabled = false,
	clickable = false,
	onClick,
}: IconicRowProps) => {
	return (
		<Flex
			justify="space-between"
			onClick={onClick}
			className={classNames({
				[classes.clickable]: clickable,
				[classes.disabled]: disabled,
			})}
		>
			<Flex direction="column" maw={300}>
				<Flex align="center" gap={5}>
					<Text size="md" fw={600}>
						{mainText}
					</Text>
					{badge && (
						<Button color="green" autoContrast={true} variant="filled" radius="xl" px={10} h={24}>
							{badge}
						</Button>
					)}
				</Flex>
				{dimmedText && (
					<Text c="dimmed" size="sm" fw={500}>
						{dimmedText}
					</Text>
				)}
			</Flex>
			<Flex align="center" gap={5}>
				{rightContentSlot && (
					<Flex direction="column" ta={'right'}>
						{rightContentSlot}
					</Flex>
				)}
				<IconChevronRight color="rgba(102, 112, 133, .5)" cursor="pointer" fontSize={12} />
			</Flex>
		</Flex>
	);
};
